import './App.css';
import React from 'react';
import RouterPage from './_helpers/routerPage';

class App extends React.Component{
  constructor(props) {
    super(props);
  }
  
  render(){
    return(
      <RouterPage />
    )
  }
}

export default App;
